import createActionType from "../utils/createActionType";

const MODULE = "materials";

export const SEARCH_MATERIALS = createActionType(MODULE, "searchMaterials");
